<script>
export default {
	data: () => {
		return {
			copyrightDate: new Date().getFullYear(),
		};
	},
};
</script>

<template>
	<div class="flex justify-center items-center text-center">
		<div
			class="font-general-regular text-lg text-ternary-dark dark:text-ternary-light"
		>
			&copy; {{ copyrightDate }} Joseph Valdez
		</div>
	</div>
</template>
